export function registerServiceWorker(
  onUpdate?: (registration: ServiceWorkerRegistration) => void
) {
  if (!("serviceWorker" in navigator)) return;

  const register = async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");

      // SW already waiting (e.g. user revisits after deploy)
      if (reg.waiting) {
        onUpdate?.(reg);
        return;
      }

      // New SW found — wait for it to install
      reg.addEventListener("updatefound", () => {
        const newWorker = reg.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            onUpdate?.(reg);
          }
        });
      });
    } catch (err) {
      console.warn("SW registration failed:", err);
    }
  };

  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register);
  }

  // Another tab triggered skipWaiting — reload to get the new version
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}
